// extracted by mini-css-extract-plugin
export default {"options":"VoteForm_options__3HHEi","option":"VoteForm_option__U4dEE","active":"VoteForm_active__I94Re"};